
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j0Fou", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $8Bzrf = parcelRequire("8Bzrf");


var $eHv8q = parcelRequire("eHv8q");


var $9OLUt = parcelRequire("9OLUt");


var $42omo = parcelRequire("42omo");

const $68a42afbf7553230$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        if ((0, $c6GJD.default).checkGate('post-office-use-placement-with-client')) return (0, $9OLUt.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $eHv8q.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $42omo.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $68a42afbf7553230$export$201bbce8187a6e3c;

});

parcelRegister("eHv8q", function(module, exports) {

var $2OGMq = parcelRequire("2OGMq");


var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $872a969cc90d2799$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $42omo.useRef)();
        const isRunningPromise = (0, $42omo.useRef)(false);
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $42omo.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gAOec.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $2OGMq.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gAOec.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};
module.exports["createUsePlacement"] = $872a969cc90d2799$export$ee1d67e435d25cb5;

});

parcelRegister("2OGMq", function(module, exports) {
const $c9d2f99792ae105c$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $c9d2f99792ae105c$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $c9d2f99792ae105c$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$c9d2f99792ae105c$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $c9d2f99792ae105c$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($c9d2f99792ae105c$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$c9d2f99792ae105c$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};
module.exports["fetchPlacementData"] = $c9d2f99792ae105c$export$ce743d02f83ee521;

});

parcelRegister("9OLUt", function(module, exports) {

var $hy3a0 = parcelRequire("hy3a0");


var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");

const $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $hy3a0.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};
module.exports["createUsePlacementWithClient"] = $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1;

});

parcelRegister("hy3a0", function(module, exports) {

var $fCcUZ = parcelRequire("fCcUZ");

const $785c8761b65409e5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $785c8761b65409e5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $785c8761b65409e5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$785c8761b65409e5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $785c8761b65409e5$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $785c8761b65409e5$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($785c8761b65409e5$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$785c8761b65409e5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $fCcUZ.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$785c8761b65409e5$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
module.exports["useFetchPlacementData"] = $785c8761b65409e5$export$ef70136078f15deb;

});

parcelRegister("cJD7j", function(module, exports) {

var $75pAy = parcelRequire("75pAy");


var $dmbyO = parcelRequire("dmbyO");


var $f8fs7 = parcelRequire("f8fs7");


var $fyAGy = parcelRequire("fyAGy");


var $98FJC = parcelRequire("98FJC");


var $lVBvv = parcelRequire("lVBvv");

const $1f1764be7897cc40$var$TUNNEL_FEATURE_GATE = 'post-office_enable-in-app-v2-placement-tunnel';
const $1f1764be7897cc40$export$cbba1ff0a3203010 = (baseConfig)=>{
    const tunnelPlacementBackendRuntimeConfigBuilder = new (0, $fyAGy.TunnelPlacementBackendRuntimeConfigBuilder)();
    return ({ koa: koa, request: request })=>{
        const enableBypassBuffer = request.statsig.checkGate({
            identifiers: {
                atlassianAccountId: request?.orchestrationContext?.recipient?.toString()
            }
        }, 'post-office_enable_bypass-data');
        // This is stateful mechanism to allow placement stages to send none message data between them.
        // Examples include grouping data, or other metadata provided by the placement.
        // Orchestration messageSelection only accepts PipelineMessage[] as an input, which means we can't add it to the pipeline payload. >(ভ⤙ ভ ")<
        // Be aware that because this is stateful it is dangerous. Be sure that this only is instantiated per request to prevent metadata
        // cross contamination between requests
        const bypassBuffer = $1f1764be7897cc40$var$createBypassBuffer();
        const orchestrationRequest = request.location.tag({
            placementLevel: 'PostOffice'
        });
        return async (params)=>{
            let finalConfig = baseConfig;
            const isTunnelEnabled = request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: request.orchestrationContext.recipient.userId
                }
            }, $1f1764be7897cc40$var$TUNNEL_FEATURE_GATE);
            if (isTunnelEnabled) try {
                const placementId = baseConfig.placementId;
                const tunnelledConfig = await tunnelPlacementBackendRuntimeConfigBuilder.buildConfigOverlay({
                    placementId: placementId,
                    params: params,
                    requestContext: request,
                    baseConfig: baseConfig
                });
                finalConfig = (0, $f8fs7.mergePlacementConfigs)(baseConfig, tunnelledConfig);
                request.logger.info({
                    placementId: placementId,
                    hasTunnelledConfig: Object.keys(tunnelledConfig).length > 0
                }, '[Tunnel] Config overlay applied');
            } catch (error) {
                request.logger.error({
                    error: error,
                    placementId: baseConfig.placementId
                }, '[Tunnel] Failed to build overlay config, falling back to base config');
                finalConfig = baseConfig;
            }
            const tunnelDepsFromKoaContext = {
                whitelistProxyHost: koa.ctx.config.micros.whitelistProxyHost,
                allowRemoteExecution: koa.ctx.config.remoteExecution.allowRemoteExecution
            };
            const placementStages = (0, $dmbyO.createPlacementStages)(finalConfig);
            const stageProcessors = $1f1764be7897cc40$var$placementStagesToStageProcessors(placementStages, tunnelDepsFromKoaContext);
            const stages = stageProcessors({
                request: request,
                bypassBuffer: bypassBuffer,
                enableBypassBuffer: enableBypassBuffer
            });
            const messages = await koa.ctx.messageSelection.getEligibleMessages(orchestrationRequest, {
                ...params,
                stages: stages
            });
            if (enableBypassBuffer) {
                const bypassData = bypassBuffer.getOnce();
                return {
                    data: {
                        ...bypassData,
                        messages: messages
                    },
                    // Add error output when compatible with orchestration
                    errors: []
                };
            }
            return {
                data: {
                    messages: messages
                },
                // Add error output when compatible with orchestration
                errors: []
            };
        };
    };
};
const $1f1764be7897cc40$var$placementStagesToStageProcessors = (placementStages, tunnelDepsFromKoaContext)=>(contexts)=>{
        const stageProcessors = {};
        Object.entries(placementStages).forEach((stage)=>{
            const [stageName] = stage;
            stageProcessors[stageName] = $1f1764be7897cc40$var$placementStageToStageProcessor({
                ...contexts,
                tunnelDepsFromKoaContext: tunnelDepsFromKoaContext
            })(stage);
        });
        return stageProcessors;
    };
const $1f1764be7897cc40$var$placementStageToStageProcessor = ({ request: request, bypassBuffer: bypassBuffer, enableBypassBuffer: enableBypassBuffer, tunnelDepsFromKoaContext: tunnelDepsFromKoaContext })=>([stageName, placementStage])=>{
        return (options)=>{
            const { tunnelTestingOverridesService: tunnelTestingOverridesService, userDetailsProvider: userDetailsProvider, tunnelManagerFactory: tunnelManagerFactory } = options.deps;
            const tunnelDependencies = {
                ...tunnelDepsFromKoaContext,
                tunnelTestingOverridesService: tunnelTestingOverridesService,
                userDetailsProvider: userDetailsProvider,
                tunnelManagerFactory: tunnelManagerFactory
            };
            // Create execute function with access to tunnelDependencies
            const execute = $1f1764be7897cc40$var$placementStageToStageProcessorExecute(placementStage)({
                request: request,
                bypassBuffer: bypassBuffer,
                enableBypassBuffer: enableBypassBuffer,
                tunnelDependencies: tunnelDependencies,
                stageName: stageName
            });
            return {
                id: stageName,
                execute: execute
            };
        };
    };
const $1f1764be7897cc40$var$createBypassBuffer = ()=>{
    let state = undefined;
    const getOnce = ()=>{
        const once = state;
        flush();
        return once;
    };
    const set = (buffer)=>{
        state = buffer;
    };
    const flush = ()=>{
        state = undefined;
    };
    return {
        getOnce: getOnce,
        set: set,
        flush: flush
    };
};
const $1f1764be7897cc40$var$placementStageToStageProcessorExecute = (placementStage = $1f1764be7897cc40$var$identityPlacementStage)=>({ request: request, bypassBuffer: bypassBuffer, enableBypassBuffer: enableBypassBuffer, tunnelDependencies: tunnelDependencies, stageName: stageName })=>async (pipelineMessages)=>{
            const placementId = request.orchestrationContext.placementId;
            try {
                const tunnelDecision = await (0, $98FJC.checkShouldTunnelStage)({
                    request: request,
                    pipelineMessages: pipelineMessages,
                    tunnelDependencies: tunnelDependencies,
                    stageName: stageName,
                    placementId: placementId
                });
                if (tunnelDecision.enabled) return await (0, $lVBvv.executePlacementStageTunneled)({
                    request: request,
                    pipelineMessages: pipelineMessages,
                    stageName: stageName,
                    placementId: placementId,
                    messageTemplateIds: tunnelDecision.messageTemplateIds,
                    remoteTunnelManager: tunnelDecision.remoteTunnelManager,
                    stripUnserializablePayload: $1f1764be7897cc40$var$stripUnserializablePayload
                });
            } catch (error) {
                request.logger.error({
                    error: error,
                    stageName: stageName,
                    placementId: placementId
                }, 'Error with checking or executing tunnel placement stage. Falling back to production execution.');
            // Fall through to production execution
            }
            const placementMessages = pipelineMessages.map($1f1764be7897cc40$var$stripUnserializablePayload);
            const pipelineMessagesByMessageInstanceId = Object.fromEntries(pipelineMessages.map((pipelineMessage)=>[
                    pipelineMessage.messageInstanceId,
                    pipelineMessage
                ]));
            $1f1764be7897cc40$var$validateSerializablePayload(placementMessages);
            if (enableBypassBuffer) {
                const bypassInput = bypassBuffer.getOnce();
                const processedData = await placementStage({
                    data: {
                        ...bypassInput,
                        messages: placementMessages
                    },
                    request: request
                });
                const { messages: _, ...bypassOutput } = processedData;
                bypassBuffer.set(bypassOutput);
                const combinedMessages = processedData.messages.map((processedMessage)=>({
                        ...pipelineMessagesByMessageInstanceId[processedMessage.messageInstanceId],
                        ...processedMessage
                    }));
                return combinedMessages;
            }
            const processedData = await placementStage({
                data: {
                    messages: placementMessages
                },
                request: request
            });
            const combinedMessages = processedData.messages.map((processedMessage)=>({
                    ...pipelineMessagesByMessageInstanceId[processedMessage.messageInstanceId],
                    ...processedMessage
                }));
            return combinedMessages;
        };
const $1f1764be7897cc40$var$stripUnserializablePayload = (pipelineMessage)=>({
        messageInstanceId: pipelineMessage.messageInstanceId,
        messageTemplateId: pipelineMessage.messageTemplateId,
        messageCategory: pipelineMessage.messageConfig.messageCategory,
        createdAt: pipelineMessage.createdAt,
        eventTime: pipelineMessage.eventTime,
        context: pipelineMessage.context,
        triggerId: pipelineMessage.triggerId,
        messageCreationType: pipelineMessage.messageCreationType,
        recommendationSession: pipelineMessage.recommendationSession,
        readStatus: pipelineMessage.readStatus
    });
const $1f1764be7897cc40$var$validateSerializablePayload = (payload)=>{
    try {
        JSON.stringify(payload);
    } catch  {
        throw new (0, $75pAy.PlacementSystemError)({
            message: 'failed to backend message body, this may mean a non-serializable field has to been added and should be removed'
        });
    }
};
const $1f1764be7897cc40$var$identityPlacementStage = async (input)=>input.data;
module.exports["productionRuntime"] = $1f1764be7897cc40$export$cbba1ff0a3203010;

});

parcelRegister("75pAy", function(module, exports) {

var $hOVIX = parcelRequire("hOVIX");

class $604a5d8496a5c3da$export$3d5f437b74b20d52 extends (0, $hOVIX.PostOfficeError) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? 'unknown placement system error';
        const code = params.code ?? (0, $hOVIX.PostOfficeErrorCodes).PlacementSystemError;
        super(message, code);
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.stageName = void 0;
        this.placementLevel = void 0;
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
class $604a5d8496a5c3da$export$8a38dc1cb159944a extends $604a5d8496a5c3da$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement message error',
            code: (0, $hOVIX.PostOfficeErrorCodes).PlacementMessageError
        });
    }
}
class $604a5d8496a5c3da$export$321382f6614c450c extends $604a5d8496a5c3da$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement error',
            code: (0, $hOVIX.PostOfficeErrorCodes).PlacementError
        });
    }
}
class $604a5d8496a5c3da$export$c8e5ef21fa31d723 extends $604a5d8496a5c3da$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement runtime error',
            code: (0, $hOVIX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
class $604a5d8496a5c3da$export$20e3e1204742e375 extends $604a5d8496a5c3da$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement middleware error',
            code: (0, $hOVIX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
const $604a5d8496a5c3da$export$33fc68e75ae0d686 = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $604a5d8496a5c3da$export$ee31fecb3809975f = $604a5d8496a5c3da$export$33fc68e75ae0d686($604a5d8496a5c3da$export$3d5f437b74b20d52);
const $604a5d8496a5c3da$export$6536fa2f9f327746 = (request)=>(error)=>$604a5d8496a5c3da$export$795c072ee2f403d0(request)($604a5d8496a5c3da$export$ee31fecb3809975f(error));
const $604a5d8496a5c3da$export$72b956efef19a76d = $604a5d8496a5c3da$export$33fc68e75ae0d686($604a5d8496a5c3da$export$3d5f437b74b20d52);
const $604a5d8496a5c3da$export$fac04fc2e7d95393 = (request)=>(error)=>$604a5d8496a5c3da$export$795c072ee2f403d0(request)($604a5d8496a5c3da$export$72b956efef19a76d(error));
const $604a5d8496a5c3da$export$8fe51a926669e297 = $604a5d8496a5c3da$export$33fc68e75ae0d686($604a5d8496a5c3da$export$3d5f437b74b20d52);
const $604a5d8496a5c3da$export$76f72ccfbe960ca1 = (request)=>(error)=>$604a5d8496a5c3da$export$795c072ee2f403d0(request)($604a5d8496a5c3da$export$8fe51a926669e297(error));
const $604a5d8496a5c3da$export$149a31b9f5a4a9c2 = $604a5d8496a5c3da$export$33fc68e75ae0d686($604a5d8496a5c3da$export$c8e5ef21fa31d723);
const $604a5d8496a5c3da$export$146aabc04248e280 = (request)=>(error)=>$604a5d8496a5c3da$export$795c072ee2f403d0(request)($604a5d8496a5c3da$export$149a31b9f5a4a9c2(error));
const $604a5d8496a5c3da$export$572d500120860974 = $604a5d8496a5c3da$export$33fc68e75ae0d686($604a5d8496a5c3da$export$20e3e1204742e375);
const $604a5d8496a5c3da$export$e644214358a6da92 = (request)=>(error)=>$604a5d8496a5c3da$export$795c072ee2f403d0(request)($604a5d8496a5c3da$export$572d500120860974(error));
const $604a5d8496a5c3da$export$795c072ee2f403d0 = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };
module.exports["PlacementSystemError"] = $604a5d8496a5c3da$export$3d5f437b74b20d52;
module.exports["PlacementMessageError"] = $604a5d8496a5c3da$export$8a38dc1cb159944a;
module.exports["createPlacementMessageError"] = $604a5d8496a5c3da$export$ee31fecb3809975f;
module.exports["handlePlacementMessageError"] = $604a5d8496a5c3da$export$6536fa2f9f327746;
module.exports["handlePlacementError"] = $604a5d8496a5c3da$export$fac04fc2e7d95393;
module.exports["handlePlacementRuntimeError"] = $604a5d8496a5c3da$export$146aabc04248e280;
module.exports["handlePlacementMiddlewareError"] = $604a5d8496a5c3da$export$e644214358a6da92;

});

parcelRegister("dmbyO", function(module, exports) {

var $75pAy = parcelRequire("75pAy");

const $8935ec94c760bc0b$export$92374210cfb1952e = (config)=>{
    const placementMessagesStages = $8935ec94c760bc0b$export$a5c10ed60365dc32(config.messagesStages);
    return config.placementStages(placementMessagesStages);
};
const $8935ec94c760bc0b$export$a5c10ed60365dc32 = (messagesStages)=>{
    const messagesStagesByStageName = $8935ec94c760bc0b$export$3be438872ca64c45(messagesStages);
    const placementMessageStages = {};
    Object.entries(messagesStagesByStageName).forEach(([stageName, stage])=>{
        const messageStage = $8935ec94c760bc0b$export$e43344e8c8930b68(stage);
        if (placementMessageStages[stageName]) throw new (0, $75pAy.PlacementMessageError)({
            message: 'a duplicate stage name was found. Stage names should be unique'
        });
        const placementMessageStage = $8935ec94c760bc0b$export$64a9f617bf229a12(messageStage);
        $8935ec94c760bc0b$var$nameFunction(stageName, placementMessageStage);
        placementMessageStages[stageName] = placementMessageStage;
    });
    return placementMessageStages;
};
const $8935ec94c760bc0b$export$64a9f617bf229a12 = (messageStage)=>async ({ data: data, request: request })=>{
        const result = await $8935ec94c760bc0b$export$c86138aa03618dd1(messageStage)({
            data: data,
            request: request
        });
        const inputCount = data.messages.length;
        const successCount = result.data.messages.length;
        if (result.errors.length) {
            const uniqueErroredMessageTemplateIds = Array.from(new Set(result.errors.map((error)=>error.messageTemplateId)).values());
            result.errors.forEach((error)=>request.logger.error({
                    messageTemplateId: error.messageTemplateId,
                    messageInstanceId: error.messageInstanceId,
                    reason: error.reason
                }, 'error running message stage in placement'));
            request.logger.error({
                errors: result.errors,
                messageTemplateIds: uniqueErroredMessageTemplateIds,
                inputCount: inputCount,
                successCount: successCount
            }, 'errors running some messages in placement');
        }
        return result.data;
    };
const $8935ec94c760bc0b$export$3be438872ca64c45 = (messagesStages)=>{
    const messagesStagesByStageName = {};
    Object.entries(messagesStages).forEach(([messageTemplateId, messageStages])=>Object.entries(messageStages).forEach(([stageName, messageStage])=>{
            if (!messagesStagesByStageName?.[stageName]) messagesStagesByStageName[stageName] = {};
            const asAsyncMessageStage = async (params)=>messageStage(params);
            // We can use non null assertion as we initilize above
            messagesStagesByStageName[stageName][messageTemplateId] = asAsyncMessageStage;
        }));
    return messagesStagesByStageName;
};
// This should return a message context
const $8935ec94c760bc0b$var$identityMessageStage = async ({ message: message })=>message;
const $8935ec94c760bc0b$export$e43344e8c8930b68 = (stage)=>({ request: request, message: message })=>{
        const stageProcessor = stage?.[message.messageTemplateId] ?? $8935ec94c760bc0b$var$identityMessageStage;
        return stageProcessor({
            request: request,
            message: message
        });
    };
const $8935ec94c760bc0b$export$c86138aa03618dd1 = (messageStage)=>async ({ data: data, request: request })=>{
        const processMessage = async (message)=>messageStage({
                request: request,
                message: message
            });
        const promises = data.messages.map(processMessage);
        const results = await Promise.allSettled(promises);
        const messages = results.filter((settledResult)=>{
            return settledResult.status === 'fulfilled';
        }).map((e)=>e.value);
        const errors = results.map((settledResult, index)=>{
            if (settledResult.status === 'rejected') {
                const originalMessage = data.messages?.[index];
                const messageInstanceId = originalMessage?.messageInstanceId;
                const messageTemplateId = originalMessage?.messageTemplateId;
                return {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    ...settledResult
                };
            }
            return settledResult;
        }).filter((e)=>e.status === 'rejected').map(({ status: _status, ...rest })=>rest);
        return {
            data: {
                messages: messages
            },
            errors: errors
        };
    };
const $8935ec94c760bc0b$var$nameFunction = (name, fn)=>Object.defineProperty(fn, 'name', {
        value: name
    });
module.exports["createPlacementStages"] = $8935ec94c760bc0b$export$92374210cfb1952e;

});

parcelRegister("f8fs7", function(module, exports) {
function $07c66557c5876ba6$export$9acac69249b93495(base, overlay) {
    // If overlay is empty, return base unchanged
    if (!overlay.placementStages && !overlay.messagesStages) return base;
    const merged = {
        ...base,
        // Shallow copy to allow selective overrides
        placementStages: base.placementStages,
        messagesStages: {
            ...base.messagesStages
        }
    };
    // Override placement stages if present in overlay
    if (overlay.placementStages) merged.placementStages = overlay.placementStages;
    // Merge message template stages (per-template selective override)
    if (overlay.messagesStages) Object.entries(overlay.messagesStages).forEach(([messageTemplateId, stages])=>{
        merged.messagesStages[messageTemplateId] = stages;
    });
    return merged;
}
module.exports["mergePlacementConfigs"] = $07c66557c5876ba6$export$9acac69249b93495;

});

parcelRegister("fyAGy", function(module, exports) {
class $ad357ced3340e2c8$export$b18dec239832c24d {
    async buildConfigOverlay(_input) {
        // TODO: Implement selective tunnelling decisions
        // For now, return empty overlay (no changes to base config)
        // Example future implementation:
        // 1. Check which stages to tunnel via shouldTunnelStage(stageName, placementId)
        // 2. Check which templates to tunnel via shouldTunnelTemplate(templateKey, placementId)
        // 3. Fetch tunnel config for selected stages/templates from local server
        // 4. Return partial config with only the tunnelled parts
        return {};
    }
    constructor(){}
}
module.exports["TunnelPlacementBackendRuntimeConfigBuilder"] = $ad357ced3340e2c8$export$b18dec239832c24d;

});

parcelRegister("98FJC", function(module, exports) {
const $98e9dc8764ff737f$var$TUNNEL_FEATURE_GATE = 'post-office_enable-in-app-v2-placement-tunnel';
const $98e9dc8764ff737f$export$de9d9248955dc274 = async ({ request: request, pipelineMessages: pipelineMessages, tunnelDependencies: tunnelDependencies, stageName: stageName, placementId: placementId })=>{
    const recipientAccountId = request.orchestrationContext.recipient.userId;
    if (!$98e9dc8764ff737f$var$isRemoteExecutionAllowed(tunnelDependencies)) return {
        enabled: false
    };
    if (!$98e9dc8764ff737f$var$isTunnelFeatureGateEnabled(request, recipientAccountId)) return {
        enabled: false
    };
    try {
        const { hasTunnelledMessageTemplateIds: hasTunnelledMessageTemplateIds, messageTemplateIds: messageTemplateIds } = await $98e9dc8764ff737f$var$hasTunnelledMessageTemplateIdsInPipeline(tunnelDependencies, recipientAccountId, pipelineMessages);
        if (!hasTunnelledMessageTemplateIds) return {
            enabled: false
        };
        const remoteTunnelManager = await $98e9dc8764ff737f$var$setUpRemoteTunnelManager(tunnelDependencies, recipientAccountId, request, placementId, stageName);
        if (!remoteTunnelManager) return {
            enabled: false
        };
        return {
            enabled: true,
            messageTemplateIds: messageTemplateIds,
            remoteTunnelManager: remoteTunnelManager
        };
    } catch (error) {
        request.logger.warn({
            error: error,
            recipientAccountId: recipientAccountId,
            placementId: placementId,
            stageName: stageName
        }, '[Tunnel] Failed to check tunnel overrides or create tunnel manager');
        return {
            enabled: false
        };
    }
};
// This is the environment variable set for all tunnelling cases, regardless of what delivery channel is used.
// Tunnelling is only supported in Staging commercial, where this variable is set to true.
const $98e9dc8764ff737f$var$isRemoteExecutionAllowed = (tunnelDependencies)=>{
    return tunnelDependencies.allowRemoteExecution === true;
};
const $98e9dc8764ff737f$var$isTunnelFeatureGateEnabled = (request, recipientAccountId)=>{
    return request.statsig.checkGate({
        identifiers: {
            atlassianAccountId: recipientAccountId
        }
    }, $98e9dc8764ff737f$var$TUNNEL_FEATURE_GATE);
};
const $98e9dc8764ff737f$var$getTunnelOverrides = async (tunnelDependencies, recipientAccountId)=>{
    const overrides = await tunnelDependencies.tunnelTestingOverridesService.getOverridesByAccountId(recipientAccountId);
    if (!overrides?.messageTemplateIds?.length) return null;
    return overrides.messageTemplateIds;
};
const $98e9dc8764ff737f$var$hasTunnelledMessageTemplateIdsInPipeline = async (tunnelDependencies, recipientAccountId, pipelineMessages)=>{
    const overrides = await $98e9dc8764ff737f$var$getTunnelOverrides(tunnelDependencies, recipientAccountId);
    if (!overrides) return {
        hasTunnelledMessageTemplateIds: false,
        messageTemplateIds: []
    };
    const allMessageTemplateIdsInPipeline = new Set(pipelineMessages.map((msg)=>msg.messageTemplateId));
    const tunnelledMessageTemplateIds = overrides.filter((id)=>allMessageTemplateIdsInPipeline.has(id));
    return {
        hasTunnelledMessageTemplateIds: tunnelledMessageTemplateIds.length > 0,
        messageTemplateIds: tunnelledMessageTemplateIds
    };
};
const $98e9dc8764ff737f$var$setUpRemoteTunnelManager = async (tunnelDependencies, recipientAccountId, request, placementId, stageName)=>{
    // Check if factory is available (only provided in Node.js environments)
    if (!tunnelDependencies.tunnelManagerFactory) {
        request.logger.warn({
            placementId: placementId,
            stageName: stageName
        }, '[Tunnel] No tunnel manager factory provided - tunneling unavailable');
        return null;
    }
    const userDetails = await tunnelDependencies.userDetailsProvider.getIdentityUserDetails(recipientAccountId, true);
    const recipientEmail = userDetails.email;
    const isAtlassianStaff = recipientEmail.endsWith('@atlassian.com') || recipientEmail.endsWith('@usersinbuckets.com');
    if (!isAtlassianStaff) {
        request.logger.warn({
            recipientEmail: recipientEmail,
            placementId: placementId,
            stageName: stageName
        }, '[Tunnel] Recipient is not Atlassian staff, not setting up remote tunnel manager');
        return null;
    }
    const staffId = recipientEmail.split('@')[0] || 'unknown';
    // Use the injected factory to create the tunnel manager
    const remoteTunnelManager = tunnelDependencies.tunnelManagerFactory.createTunnelManager(staffId, request.logger, request.metrics, tunnelDependencies.whitelistProxyHost);
    return remoteTunnelManager;
};
module.exports["checkShouldTunnelStage"] = $98e9dc8764ff737f$export$de9d9248955dc274;

});

parcelRegister("lVBvv", function(module, exports) {

var $4LZfZ = parcelRequire("4LZfZ");

const $1a3b9cef86f945d3$export$81c126a0ea9ce61b = async ({ request: request, pipelineMessages: pipelineMessages, stageName: stageName, placementId: placementId, messageTemplateIds: messageTemplateIds, remoteTunnelManager: remoteTunnelManager, stripUnserializablePayload: stripUnserializablePayload })=>{
    // Strip non-serializable fields from messages
    // Same behaviour as production
    const placementMessages = pipelineMessages.map(stripUnserializablePayload);
    const requestContext = {
        orchestrationContext: request.orchestrationContext,
        appConfig: request.appConfig,
        slauth: request.slauth,
        headers: request.headers,
        body: request.body,
        query: request.query,
        url: request.url
    };
    const result = await remoteTunnelManager.makeRemoteTunnelRequest({
        route: '/in-app-v2/execute-placement-stage',
        method: 'POST',
        data: {
            placementId: placementId,
            stageName: stageName,
            messages: placementMessages,
            messageTemplateIds: messageTemplateIds,
            requestContext: requestContext
        },
        validator: (0, $4LZfZ.isVBackendMessageBodyArray)
    });
    // Merge with original pipeline messages to preserve non-serializable fields
    // Same behaviour as production
    const pipelineMessagesByMessageInstanceId = Object.fromEntries(pipelineMessages.map((pm)=>[
            pm.messageInstanceId,
            pm
        ]));
    const combinedMessages = result.messages.map((processedMessage)=>({
            ...pipelineMessagesByMessageInstanceId[processedMessage.messageInstanceId],
            ...processedMessage
        }));
    return combinedMessages;
};
module.exports["executePlacementStageTunneled"] = $1a3b9cef86f945d3$export$81c126a0ea9ce61b;

});

parcelRegister("4LZfZ", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $kd6Go = parcelRequire("kd6Go");

function $ae7cffaa87396d85$export$a7a9523472993e97(value) {
    const result = $ae7cffaa87396d85$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $ae7cffaa87396d85$export$226b3eccf92c9ed9(value) {
    const result = $ae7cffaa87396d85$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $ae7cffaa87396d85$var$validateSerializablePayload(value) {
    const errors = [];
    {
        let value_valid = false;
        if (!value_valid) {
            const value_errors_0 = [];
            if (typeof value !== 'string') value_errors_0.push({
                path: 'value',
                expected: 'string',
                value: value
            });
            if (value_errors_0.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_1 = [];
            if (typeof value !== 'number') value_errors_1.push({
                path: 'value',
                expected: 'number',
                value: value
            });
            if (value_errors_1.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_2 = [];
            if (typeof value !== 'boolean') value_errors_2.push({
                path: 'value',
                expected: 'boolean',
                value: value
            });
            if (value_errors_2.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_3 = [];
            if (value !== null) value_errors_3.push({
                path: 'value',
                expected: 'null',
                value: value
            });
            if (value_errors_3.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_4 = [];
            if (typeof value !== "undefined") value_errors_4.push({
                path: 'value',
                expected: 'undefined',
                value: value
            });
            if (value_errors_4.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_5 = [];
            if (typeof value !== 'object' || value === null || Array.isArray(value)) value_errors_5.push({
                path: 'value',
                expected: 'object',
                value: value
            });
            else {
                for(const key in value)if (value.hasOwnProperty(key)) {
                    if (typeof key !== 'string') value_errors_5.push({
                        path: 'key',
                        expected: 'string',
                        value: key
                    });
                    const recursiveResult = $ae7cffaa87396d85$var$validateSerializablePayload(value[key]);
                    if (!recursiveResult.success) value_errors_5.push(...recursiveResult.errors.map((err)=>({
                            ...err,
                            path: `value["${key}"]${err.path.slice(5)}`
                        })));
                }
            }
            if (value_errors_5.length === 0) value_valid = true;
        }
        if (!value_valid) {
            const value_errors_6 = [];
            if (!Array.isArray(value)) value_errors_6.push({
                path: 'value',
                expected: 'array',
                value: value
            });
            if (value_errors_6.length === 0) value_valid = true;
        }
        if (!value_valid) errors.push({
            path: 'value',
            expected: 'string | number | boolean | null | undefined | object | SerializablePayload[]',
            value: value
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: value,
        errors: errors
    };
}
function $ae7cffaa87396d85$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'VBackendMessageBodyArray',
        value: value
    });
    else if (!('messages' in value)) errors.push({
        path: 'value["messages"]',
        expected: 'SerializableRecord[]',
        value: undefined
    });
    else {
        if (!Array.isArray(value["messages"])) errors.push({
            path: 'value["messages"]',
            expected: 'array',
            value: value["messages"]
        });
        if (Array.isArray(value["messages"])) value["messages"].forEach((element, index)=>{
            if (typeof element !== 'object' || element === null || Array.isArray(element)) errors.push({
                path: 'element',
                expected: 'SerializableRecord',
                value: element
            });
            else {
                for(const key1 in element)if (element.hasOwnProperty(key1)) {
                    if (typeof key1 !== 'string') errors.push({
                        path: 'key1',
                        expected: 'string',
                        value: key1
                    });
                    const currentLevelErrors = [];
                    {
                        let element_key1__valid = false;
                        if (!element_key1__valid) {
                            const element_key1__errors_0 = [];
                            if (typeof element[key1] !== 'string') element_key1__errors_0.push({
                                path: 'element[key1]',
                                expected: 'string',
                                value: element[key1]
                            });
                            if (element_key1__errors_0.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_1 = [];
                            if (typeof element[key1] !== 'number') element_key1__errors_1.push({
                                path: 'element[key1]',
                                expected: 'number',
                                value: element[key1]
                            });
                            if (element_key1__errors_1.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_2 = [];
                            if (typeof element[key1] !== 'boolean') element_key1__errors_2.push({
                                path: 'element[key1]',
                                expected: 'boolean',
                                value: element[key1]
                            });
                            if (element_key1__errors_2.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_3 = [];
                            if (element[key1] !== null) element_key1__errors_3.push({
                                path: 'element[key1]',
                                expected: 'null',
                                value: element[key1]
                            });
                            if (element_key1__errors_3.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_4 = [];
                            if (typeof element[key1] !== "undefined") element_key1__errors_4.push({
                                path: 'element[key1]',
                                expected: 'undefined',
                                value: element[key1]
                            });
                            if (element_key1__errors_4.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_5 = [];
                            if (typeof element[key1] !== 'object' || element[key1] === null || Array.isArray(element[key1])) element_key1__errors_5.push({
                                path: 'element[key1]',
                                expected: 'object',
                                value: element[key1]
                            });
                            else {
                                for(const key2 in element[key1])if (element[key1].hasOwnProperty(key2)) {
                                    if (typeof key2 !== 'string') element_key1__errors_5.push({
                                        path: 'key2',
                                        expected: 'string',
                                        value: key2
                                    });
                                    const recursiveResult = $ae7cffaa87396d85$var$validateSerializablePayload(element[key1][key2]);
                                    if (!recursiveResult.success) element_key1__errors_5.push(...recursiveResult.errors.map((err)=>({
                                            ...err,
                                            path: `element[key1]["${key2}"]${err.path.slice(5)}`
                                        })));
                                }
                            }
                            if (element_key1__errors_5.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) {
                            const element_key1__errors_6 = [];
                            if (!Array.isArray(element[key1])) element_key1__errors_6.push({
                                path: 'element[key1]',
                                expected: 'array',
                                value: element[key1]
                            });
                            if (element_key1__errors_6.length === 0) element_key1__valid = true;
                        }
                        if (!element_key1__valid) currentLevelErrors.push({
                            path: 'element[key1]',
                            expected: 'string | number | boolean | null | undefined | object | SerializablePayload[]',
                            value: element[key1]
                        });
                    }
                    errors.push(...currentLevelErrors.map((err)=>({
                            ...err,
                            path: `element["${key1}"]`
                        })));
                }
            }
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}
module.exports["isVBackendMessageBodyArray"] = $ae7cffaa87396d85$export$226b3eccf92c9ed9;

});

parcelRegister("kd6Go", function(module, exports) {
"use strict";
var $eb6a3497144f6692$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb6a3497144f6692$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $eb6a3497144f6692$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$eb6a3497144f6692$var$__exportStar((parcelRequire("8Qilb")), module.exports);

$eb6a3497144f6692$var$__exportStar((parcelRequire("2vd6j")), module.exports);

});

parcelRegister("8Qilb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AssertError = void 0;
class $67016827d8db46e5$var$AssertError extends Error {
    constructor(method, path, expected, value){
        const message = path ? `Error on ${method}(): invalid type on ${path}, expect to be ${expected}` : `Error on ${method}(): invalid type, expect to be ${expected}`;
        super(message);
        this.method = method;
        this.path = path;
        this.expected = expected;
        this.value = value;
    }
}
module.exports.AssertError = $67016827d8db46e5$var$AssertError;

});

parcelRegister("2vd6j", function(module, exports) {
"use strict";
var $1d28a39547970c62$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d28a39547970c62$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1d28a39547970c62$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1d28a39547970c62$var$__exportStar((parcelRequire("LALWc")), module.exports);

});

parcelRegister("LALWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gWjCD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $bnADV = parcelRequire("bnADV");


var $jVzfH = parcelRequire("jVzfH");


var $crDNP = parcelRequire("crDNP");


var $9iUWG = parcelRequire("9iUWG");


var $cUf29 = parcelRequire("cUf29");


var $hYnlH = parcelRequire("hYnlH");


var $75pAy = parcelRequire("75pAy");


var $hwVbs = parcelRequire("hwVbs");


var $dcrb9 = parcelRequire("dcrb9");


var $60c7U = parcelRequire("60c7U");


var $dkBTx = parcelRequire("dkBTx");


var $c6GJD = parcelRequire("c6GJD");


var $cqOSB = parcelRequire("cqOSB");

const $8f5fc01c5e9651c4$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: $8f5fc01c5e9651c4$var$createFrontend(placementConfig),
        createBackend: $8f5fc01c5e9651c4$var$createBackend(placementConfig)
    };
};
/*-- Frontend --*/ const $8f5fc01c5e9651c4$var$createFrontend = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $8f5fc01c5e9651c4$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return (0, $cUf29.createPlacementComponentV2)(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $8f5fc01c5e9651c4$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: 'Message',
            stageName: config?.stageName,
            placementId: config.placementId
        };
        try {
            if (!renderableStage) {
                // eslint-disable-next-line no-console
                console.warn(new (0, $75pAy.PlacementMessageError)({
                    ...placementLocation,
                    ...config
                }));
                return null;
            }
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            }); // Will throw error if type validation fails
            const { Component: Component } = renderableStage;
            const componentPropsStable = (0, $4H1Ql.useStableObject)(props);
            // Client-triggered messages: triggerType is preserved in context by backend hydration
            const triggerType = props?.context?.triggerType;
            const hasTrigger = (0, $c6GJD.default).checkGate('post-office_enable_trigger-choreographing') && (0, $9iUWG.isClientTriggeredMessage)(triggerType);
            // Create waitForTrigger hook for triggered messages
            // Note: messageSuccessComponent is undefined here since isUFOEnabled={false}
            const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)({
                hasTrigger: hasTrigger,
                messageSuccessComponent: undefined,
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $jVzfH.MessageRendererProvider), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                children: [
                    !waitForTrigger && /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.MessageViewed), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        ...props,
                        waitForTrigger: waitForTrigger,
                        children: children
                    })
                ]
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error((0, $75pAy.createPlacementMessageError)(error));
            return null;
        }
    };
const $8f5fc01c5e9651c4$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $8f5fc01c5e9651c4$export$9681465a68237b0(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $8f5fc01c5e9651c4$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId
            })
        }), {});
};
/*-- Backend --*/ const $8f5fc01c5e9651c4$var$createBackend = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>(messageBackendConfig)=>{
                    const stagesWithDefaults = $8f5fc01c5e9651c4$var$applyDefaultMessageBackendStages(stages);
                    return [
                        messageBackendConfig.messageTemplateId,
                        stagesWithDefaults
                    ];
                },
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $60c7U.defaultBackendPlacementStages);
                    const placementId = placementConfig.placementId;
                    const placementStages = $8f5fc01c5e9651c4$export$ad7e52259531e489(placementBackendStages);
                    const messagesStages = $8f5fc01c5e9651c4$export$45fdb660a0e079d7({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const middleware = placementBackendParams?.customMiddleware ?? (0, $hYnlH.defaultPlacementMiddleware);
                    const statelessMiddleware = middleware({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const koaMiddleware = async (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        const request = ctx.state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: 'Runtime'
                            });
                            if (!configuredRequest) throw new (0, $75pAy.PlacementSystemError)({
                                message: 'request context not available at runtime call'
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const result = await (0, $dcrb9.placementRuntimeTimedStage)(statelessMessagesRuntime)(contexts)(combinedParams);
                                (0, $dcrb9.logRuntimeResult)(contexts)(result);
                                return result;
                            } catch (error) {
                                throw (0, $75pAy.handlePlacementRuntimeError)(contexts.request)(error);
                            }
                        };
                        const postOffice = {
                            messagesRuntime: messagesRuntime
                        };
                        try {
                            const middlewareRequest = request.location.tag({
                                placementLevel: 'Middleware'
                            });
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            throw (0, $75pAy.handlePlacementMiddlewareError)(request)(error);
                        } finally{
                            const includePlacementMetadata = ctx.header?.['x-include-request-metadata'] === 'true';
                            if (includePlacementMetadata) ctx.body.requestMetadata = {
                                ...describe(),
                                graph: request.location.getGraph()
                            };
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        const placementId = placementConfig.placementId;
                        return {
                            placementId: placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    return {
                        middleware: koaMiddleware,
                        config: {
                            ...placementBackendConfig,
                            ...placementBackendParams,
                            ...placementConfig
                        },
                        describe: describe
                    };
                }
        });
const $8f5fc01c5e9651c4$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries((0, $dkBTx.defaultBackendPlacementMessageStages)).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: (0, $hwVbs.noValidation)(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $8f5fc01c5e9651c4$export$ad7e52259531e489 = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = undefined;
            wrappedPlacementStages[stageName] = $8f5fc01c5e9651c4$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $8f5fc01c5e9651c4$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: 'Placement',
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            return (0, $dcrb9.placementTimedStage)(stage)({
                request: request,
                data: params.data
            });
        } catch (error) {
            throw (0, $75pAy.handlePlacementError)(request)(error);
        }
    };
const $8f5fc01c5e9651c4$export$45fdb660a0e079d7 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[messageTemplateId] above
            result[messageTemplateId][stageName] = $8f5fc01c5e9651c4$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $8f5fc01c5e9651c4$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: 'Message',
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context); // Throws if fails validation
            const messagePerformance = new (0, $bnADV.MessagePerformance)(request.metrics, {
                flow: 'pull',
                placementId: config.placementId,
                stage: 'hydration'
            });
            const hydratedContext = await messagePerformance.measureOperation(async ()=>await (0, $dcrb9.messageTimedStage)(stage)({
                    request: request,
                    message: message
                }), {
                messageTemplateId: message.messageTemplateId,
                operation: config.stageName
            });
            // V2 render functions receive a context prop
            return {
                ...message,
                context: {
                    ...hydratedContext,
                    ...message.context.triggerType !== undefined ? {
                        triggerType: message.context.triggerType
                    } : {}
                }
            };
        } catch (error) {
            throw (0, $75pAy.handlePlacementMessageError)(request)(error);
        }
    };
};
const $8f5fc01c5e9651c4$export$9681465a68237b0 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            // We can safely use a non-null assertion here as we validate the existance of
            // result[stageName] above
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};
module.exports["createPlacement"] = $8f5fc01c5e9651c4$export$a2cfeb566a0f6574;

});

parcelRegister("bnADV", function(module, exports) {
const $998febe55da4b0b0$var$instrumentedStages = [
    'data-retrieval',
    'filtering',
    'hydration'
];
const $998febe55da4b0b0$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT = 'message-performance.pull.per-placement';
const $998febe55da4b0b0$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE = 'message-performance.push.per-recipient-type';
const $998febe55da4b0b0$export$e1598914a0ab4f16 = [
    10,
    25,
    50,
    100,
    150,
    200,
    250,
    300,
    400,
    500
];
const $998febe55da4b0b0$export$5213d52f4d58d631 = [
    100,
    500,
    1000
];
class $998febe55da4b0b0$export$f5bd5a7a850da66e {
    async measureOperation(callback, tags) {
        // Metrics are namespaced:
        // * by placementId and stage for pull flow
        // * by recipientType and stage for push flow
        // to reduce cardinality;
        const metricName = this.metricNameSegments.flow === 'pull' ? `${$998febe55da4b0b0$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT}.${this.metricNameSegments.placementId}.${this.metricNameSegments.stage}` : `${$998febe55da4b0b0$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE}.${this.metricNameSegments.recipientType}.${this.metricNameSegments.stage}`;
        const HISTOGRAM_LATENCY_INTERVAL_BUCKETS = this.metricNameSegments.flow === 'pull' ? $998febe55da4b0b0$export$e1598914a0ab4f16 : $998febe55da4b0b0$export$5213d52f4d58d631;
        // `messageTemplateId` and `operation` are added as tags to allow building charts comparing performance
        // of different message templates and observe performance problems with individual operations.
        const timer = this.metrics.histogram(metricName, HISTOGRAM_LATENCY_INTERVAL_BUCKETS, tags).measure();
        let status = 'success';
        try {
            return await callback();
        } catch (error) {
            status = 'failure';
            throw error;
        } finally{
            timer.stop({
                status: status
            });
        }
    }
    constructor(metrics, metricNameSegments){
        this.metrics = metrics;
        this.metricNameSegments = metricNameSegments;
    }
}
module.exports["MessagePerformance"] = $998febe55da4b0b0$export$f5bd5a7a850da66e;

});

parcelRegister("cUf29", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");


var $42omo = parcelRequire("42omo");

const $b8365a45e70169df$export$71ff7382870ef1b0 = 'create-placement-component';
const $b8365a45e70169df$export$66305c2a07eec241 = (placementId, Component, options)=>(0, $2HRxT.withErrorBoundary)(/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (options?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const providedContext = (0, $PAiZW.usePostOfficeContext)();
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const route = (0, $6yHRM.usePostOfficeRoute)();
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
            placementId: placementId,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $b8365a45e70169df$export$baf3e7aff0bbcf43 = (placementId, Component, options)=>{
    const placement = $b8365a45e70169df$export$66305c2a07eec241(placementId, Component, options);
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        return placement({
            ...props,
            fallbackRender: ()=>null
        });
    });
};
module.exports["createPlacementComponentV2"] = $b8365a45e70169df$export$baf3e7aff0bbcf43;

});

parcelRegister("hYnlH", function(module, exports) {

var $eoKlQ = parcelRequire("eoKlQ");

const $915e186ccd8ed4c2$export$a815601a0de834af = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, 'placement middleware error');
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: 'An error occurred'
                };
            }
        };
const $915e186ccd8ed4c2$export$c4652643d257c65 = $915e186ccd8ed4c2$export$a815601a0de834af(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $915e186ccd8ed4c2$export$af2103662bc91e89(result);
    return {
        ...result.data,
        messages: (0, $eoKlQ.flattenMessagesForFrontend)(result.data.messages)
    };
});
const $915e186ccd8ed4c2$export$af2103662bc91e89 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? 'unknown'));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > 0.1) // Better error required
    throw new Error('too many message template errors');
};
module.exports["defaultPlacementMiddleware"] = $915e186ccd8ed4c2$export$c4652643d257c65;

});

parcelRegister("eoKlQ", function(module, exports) {
const $3c2b4f3d80d96141$export$45bce7b2197b989e = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
const $3c2b4f3d80d96141$export$e578dffc38a1382b = (messages)=>messages.map($3c2b4f3d80d96141$export$45bce7b2197b989e);
module.exports["flattenMessagesForFrontend"] = $3c2b4f3d80d96141$export$e578dffc38a1382b;

});

parcelRegister("hwVbs", function(module, exports) {

var $k6fKq = parcelRequire("k6fKq");

const $5913aee239288dba$export$ed649b7c8ee8dc84 = ()=>({
        transformMetadata: {
            validate: $5913aee239288dba$export$3f7a3f360cb80be4(),
            stage: (0, $k6fKq.defaultTransformMetadata)
        }
    });
const $5913aee239288dba$export$3f7a3f360cb80be4 = (_valueWithType)=>(input)=>input;
module.exports["defaultMessageBackend"] = $5913aee239288dba$export$ed649b7c8ee8dc84;
module.exports["noValidation"] = $5913aee239288dba$export$3f7a3f360cb80be4;

});

parcelRegister("k6fKq", function(module, exports) {
const $a784ded59acbbca1$export$d56f9d28855034df = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: 'clickthrough'
            }
        }
    });
module.exports["defaultTransformMetadata"] = $a784ded59acbbca1$export$d56f9d28855034df;

});

parcelRegister("dcrb9", function(module, exports) {
const $5d90b89a613a1dc1$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1000
];
const $5d90b89a613a1dc1$var$timerName = 'post-office.placement-v2.stage.execute';
const $5d90b89a613a1dc1$var$counterName = 'post-office.placement-v2.stage.result';
const $5d90b89a613a1dc1$var$createTimedStage = (tag)=>(stage)=>async (params)=>{
            params.request.logger.info('Started stage');
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($5d90b89a613a1dc1$var$timerName, $5d90b89a613a1dc1$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn('Unable to apply tags to stage logs');
                }
                params.request.metrics.counter($5d90b89a613a1dc1$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($5d90b89a613a1dc1$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                params.request.logger.info({
                    latencyInMs: latencyInMs,
                    ...tags
                }, 'Finished stage');
            }
        };
const $5d90b89a613a1dc1$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            contexts.request.logger.info('Started stage');
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($5d90b89a613a1dc1$var$timerName, $5d90b89a613a1dc1$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($5d90b89a613a1dc1$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($5d90b89a613a1dc1$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, 'Finished stage');
            }
        };
    };
const $5d90b89a613a1dc1$export$ef814b969fe01b12 = $5d90b89a613a1dc1$var$createTimedStage();
const $5d90b89a613a1dc1$export$d1ae1adf079f8144 = $5d90b89a613a1dc1$var$createTimedStage(({ input: input, output: output })=>{
    if (!output) return {};
    const inputMessageTemplateIds = Array.from(new Set(input.data.messages.map((message)=>message.messageTemplateId)).values());
    const outputMessageTemplateIds = Array.from(new Set(output.messages.map((message)=>message.messageTemplateId)).values());
    const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIds.includes(id));
    const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
    const outputMessageInstanceIds = output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
    const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIds.includes(id));
    return {
        input: {
            number: input.data.messages.length,
            messageTemplateIds: inputMessageTemplateIds,
            messageInstanceIds: inputMessageInstanceIds
        },
        output: {
            number: output.messages.length,
            messageTemplateIds: outputMessageTemplateIds,
            messageInstanceIds: outputMessageInstanceIds
        },
        delta: {
            number: output.messages.length - input.data.messages.length,
            messageTemplateIds: deltaMessageTemplateIds,
            messageInstanceIds: deltaMessageInstanceIds
        }
    };
});
const $5d90b89a613a1dc1$export$1119d982b61d8814 = $5d90b89a613a1dc1$var$createTimedSystemStage;
const $5d90b89a613a1dc1$export$79586cc267015801 = ({ request: request })=>(result)=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, 'Runtime result');
    };
module.exports["messageTimedStage"] = $5d90b89a613a1dc1$export$ef814b969fe01b12;
module.exports["placementTimedStage"] = $5d90b89a613a1dc1$export$d1ae1adf079f8144;
module.exports["placementRuntimeTimedStage"] = $5d90b89a613a1dc1$export$1119d982b61d8814;
module.exports["logRuntimeResult"] = $5d90b89a613a1dc1$export$79586cc267015801;

});

parcelRegister("60c7U", function(module, exports) {

var $7UnG4 = parcelRequire("7UnG4");


var $fbEDv = parcelRequire("fbEDv");

const $becf341303873ff1$export$fc43c4563ceea5ce = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: (0, $fbEDv.applyTransformMetadata)(transformMetadata),
        postInit: (0, $7UnG4.applyHydrate)(hydrate)
    });
module.exports["defaultBackendPlacementStages"] = $becf341303873ff1$export$fc43c4563ceea5ce;

});

parcelRegister("7UnG4", function(module, exports) {

var $9F7pl = parcelRequire("9F7pl");

const $9bd2a27654dfb78b$export$a505170ba4b7665a = (hydrate)=>(0, $9F7pl.Stages).maybe(hydrate);
module.exports["applyHydrate"] = $9bd2a27654dfb78b$export$a505170ba4b7665a;

});

parcelRegister("9F7pl", function(module, exports) {
const $3083752d1e49149b$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $3083752d1e49149b$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            const messages = target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context));
            return {
                messages: messages
            };
        }
    };
    return applyMerge;
};
const $3083752d1e49149b$export$908c35f258f55229 = {
    maybe: /**
	 * The `maybe` function creates a passthrough stage,
	 * which applies no changes, for cases where a stage might be undefined.
	 */ $3083752d1e49149b$var$maybe,
    mergeMetadata: /**
	 * the `mergeMetadata` function is used when the result of a stage is
	 * used to modify the message payload outside the message context
	 */ $3083752d1e49149b$var$mergeMetadata
};
module.exports["Stages"] = $3083752d1e49149b$export$908c35f258f55229;

});

parcelRegister("fbEDv", function(module, exports) {

var $9F7pl = parcelRequire("9F7pl");

const $0bd18382a5337317$export$e43f344828ec0e3 = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await (0, $9F7pl.Stages).maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';
        return (0, $9F7pl.Stages).mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    'in-app': {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };
module.exports["applyTransformMetadata"] = $0bd18382a5337317$export$e43f344828ec0e3;

});

parcelRegister("dkBTx", function(module, exports) {
const $cc9ef4c0e5d660b0$export$1c5532bd04c77e4b = {
};
module.exports["defaultBackendPlacementMessageStages"] = $cc9ef4c0e5d660b0$export$1c5532bd04c77e4b;

});


//# sourceMappingURL=PageLayout.59b00e00.js.map
